import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VehiclesConfigRoutingModule } from './vehicles-config-routing.module';
import { VehiclesMenuComponent } from './vehicles-menu.component';
import { SharedModule } from '../shared/shared.module';
import { VehiclesComponent } from './vehicles/vehicles.component';
import { VehiclesConfigHubGuard } from './guard/vehicles-config-hub.guard';
import { VehiclesConfigVehiclesGuard } from './guard/vehicles-config-vehicles.guard';
import { VehiclesService } from '../vehicles/service/vehicles.service';
import { VehiclePropertiesService } from '../vehicles/service/vehicle-properties.service';
import { GroupService } from '../management/service/group.service';
import { MacAddressService } from '../vehicles/service/mac-address.service';
import { DataOptionsConnectorService } from '../shared/service/data-options-connector.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { CarrierService } from '../management/service/carrier.service';
import { ResetStopsGuard } from './line-direction-counter-reset/reset-stops.guard';
import { LineDirectionCountersResetsListComponent } from
  './line-direction-counter-reset/components/line-direction-counters-resets-list/line-direction-counters-resets-list.component';
import { MenuComponent } from './line-direction-counter-reset/components/menu/menu.component';
import { LineDirectionCountersResetsAddComponent } from
  './line-direction-counter-reset/components/line-direction-counters-resets-add/line-direction-counters-resets-add.component';
import { ImporterStpModule } from 'src/app/importer-stp/importer-stp.module';
import { FindRouteFormComponent } from
  './line-direction-counter-reset/components/line-direction-counters-resets-add/form/find-route-form/find-route-form.component';
import { SelectRouteSegmentFormComponent } from
  './line-direction-counter-reset/components/line-direction-counters-resets-add/form/select-route-segment-form/select-route-segment-form.component';
import { LineDirectionCountersResetsService } from './line-direction-counter-reset/line-direction-counters-reset.service';


@NgModule({
  declarations: [
    VehiclesMenuComponent,
    VehiclesComponent,
    LineDirectionCountersResetsListComponent,
    MenuComponent,
    LineDirectionCountersResetsAddComponent,
    FindRouteFormComponent,
    SelectRouteSegmentFormComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    VehiclesConfigRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    ImporterStpModule
  ],
  providers: [
    VehiclesConfigHubGuard,
    VehiclesConfigVehiclesGuard,
    ResetStopsGuard,
    VehiclesService,
    VehiclePropertiesService,
    GroupService,
    MacAddressService,
    DataOptionsConnectorService,
    CarrierService,
    LineDirectionCountersResetsService
  ]
})
export class VehiclesConfigModule { }
